import { useMutation, useQuery, } from "react-query";
import { useToast } from "../../../hooks/usetoast";
import DataService from '../../../config/DataServices'
import { queryClient } from "../../../config";

const { getRequest, putRequest } = DataService()
export const useSiteSettings = () => {

    return useQuery({
        queryKey: ["get-site-settings"],
        queryFn: () => {
            return getRequest("/settings")
        },
    })
}

export const useUpdateSettings = () => {
    const toast = useToast();

    return useMutation({
        mutationFn: data => {
            return putRequest("/settings", data)
        },
        onError: error => {
            toast.error(error?.message)
        },
        onSuccess: async (success) => {
            toast.success(success?.data?.message)
            queryClient?.refetchQueries('get-site-settings')
        }
    })
}